import { createReducer, on } from '@ngrx/store';
import { ReportPersonaHealthGuidelineActions } from './health-guideline.actions';
import { ReportPersonaHealthGuidelineState } from './health-guideline.inteface';
import {
  initialReportPersonaHealthGuidelineState,
  reportPersonaHealthGuidelineState
} from './health-guideline.state';

export const ReportPersonaHealthGuidelineReducer = createReducer(
  reportPersonaHealthGuidelineState,
  on(
    ReportPersonaHealthGuidelineActions.reset,
    (): ReportPersonaHealthGuidelineState =>
      initialReportPersonaHealthGuidelineState
  ),
  on(
    ReportPersonaHealthGuidelineActions.updateLoading,
    (state, { loading }): ReportPersonaHealthGuidelineState => ({
      ...state,
      loading
    })
  ),
  on(
    ReportPersonaHealthGuidelineActions.setCompatibility,
    (state, { compatibility }): ReportPersonaHealthGuidelineState => ({
      ...state,
      compatibility
    })
  ),
  on(
    ReportPersonaHealthGuidelineActions.setCareer,
    (state, { career }): ReportPersonaHealthGuidelineState => ({
      ...state,
      career
    })
  )
);
